var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{attrs:{"justify":"center","alignment":"center"}},[_c('v-col',{staticClass:"text-green mid-size",attrs:{"cols":"auto"},domProps:{"innerHTML":_vm._s(_vm.introText)}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }